<style lang="scss">
  .result {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
  }
</style>

<script>
  import NumberInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/NumberInput.svelte";

  import { totalPriceStore, priceSuffixStore } from "./stores";
</script>

<div class="result">
  <NumberInput
    label={`Total Price${$priceSuffixStore}`}
    value={$totalPriceStore}
    step="0.01"
    disabled={true}
  />
</div>
